import React, { createContext, useEffect, useState } from 'react';
import useModal from '../Components/Nav/useModal'
// Context에서 관리해줄 상태값과 메소드들을 정의합니다.


export const UserContext = createContext({
  state: {
    // width: 0,
  },
  actions: {
    // setWidth: () => {},
    // setSwiperIndex: () => {}
  }
});
// Provider를 rendering하면서 상태값과 메소드들을 전달합니다.
const UserProvider = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [breakpoint, setBreakpoint] = useState(768)
  const [locallink, setLocallink] = useState("http://localhost:8000")
  const [awslink, setAwslink] = useState("https://qurator.co.kr")
  const [token, setToken] = useState()
  const [user, setUser] = useState({})
  const {isShowing, setIsShowing} = useModal()
  const [ralist, setRalist] = useState()
  const [ra, setRa] = useState()
  const [singleRa, setSingleRa] = useState()
  const [resume, setResume] = useState()
  const [tags, setTags] = useState([])

  const [tempuser, setTempuser] = useState()
  
  const [s3link, setS3link] = useState("https://qurator-01.s3.ap-northeast-2.amazonaws.com/media")
  
  const [noimage, setNoimage] = useState("https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/noimage.png")

  const value = {
    state: { width, breakpoint, locallink, 
      awslink, token, user, isShowing, ralist, ra, singleRa, resume, tags, s3link,
    tempuser, noimage
   },
    actions: { setWidth, setBreakpoint, setLocallink, 
      setAwslink, setToken, setUser, setIsShowing, setRalist, setRa, setSingleRa, setResume, setTags, setS3link,
    setTempuser, setNoimage
  }
  };

  useEffect(()=>{
    const handleWindowResize = () => setWidth(window.innerWidth)
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  })
  
  return (
    <UserContext.Provider value={[value.state, value.actions]}>
      {children}
    </UserContext.Provider>
  );
};
const UserConsumer = UserContext.Consumer;
export { UserProvider, UserConsumer };
export default UserContext;